export default __webpack_public_path__ + "static/media/safari_icon_inactive.67a80afe.png";